const NearbyTabMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z"
			fill="#FFF2EB"
		/>
		<rect
			x={13.6367}
			y={12}
			width={3.27463}
			height={8.57143}
			rx={0.5}
			fill="url(#paint0_linear_20485_87201)"
			stroke="#190A28"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.2381 36C34.616 36 34.9224 35.6936 34.9224 35.3156V21.508C34.9224 21.2957 34.824 21.0955 34.6559 20.966L23.4591 12.3346C23.2054 12.1391 22.8499 12.1457 22.6036 12.3505L12.2467 20.9662C12.0904 21.0962 12 21.289 12 21.4923V35.3156C12 35.6936 12.3064 36 12.6844 36H34.2381Z"
			fill="#FFF2EB"
			stroke="#190A28"
		/>
		<path
			d="M21 35.4012C21 35.7319 21.2681 36 21.5988 36H25.4012C25.7319 36 26 35.7319 26 35.4012V29C26 28.4477 25.5523 28 25 28H22C21.4477 28 21 28.4477 21 29V35.4012Z"
			fill="#FFF2EB"
			stroke="#190A28"
		/>
		<path
			d="M31.3839 24.9231C31.3839 24.9231 35.9993 19.2217 35.9993 16.6523C35.9993 14.0829 33.9329 12 31.3839 12C28.8349 12 26.7686 14.0829 26.7686 16.6523C26.7686 19.2217 31.3839 24.9231 31.3839 24.9231Z"
			fill="url(#paint1_linear_20485_87201)"
			stroke="#190A28"
		/>
		<path
			d="M31.3841 18.3969C32.34 18.3969 33.1149 17.6159 33.1149 16.6523C33.1149 15.6888 32.34 14.9077 31.3841 14.9077C30.4282 14.9077 29.6533 15.6888 29.6533 16.6523C29.6533 17.6159 30.4282 18.3969 31.3841 18.3969Z"
			fill="#EBF3FE"
			stroke="#190A28"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_87201"
				x1={12.579}
				y1={14.7686}
				x2={17.9019}
				y2={17.9165}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_87201"
				x1={23.7869}
				y1={16.1743}
				x2={32.8991}
				y2={26.2494}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
		</defs>
	</svg>
);
const NearbyTabSelectedMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M44.5 24C44.5 35.3218 35.3218 44.5 24 44.5C12.6782 44.5 3.5 35.3218 3.5 24C3.5 12.6782 12.6782 3.5 24 3.5C35.3218 3.5 44.5 12.6782 44.5 24Z"
			fill="#FFF2EB"
			stroke="#DE3700"
		/>
		<rect
			x={13.6367}
			y={12}
			width={3.27463}
			height={8.57143}
			rx={0.5}
			fill="url(#paint0_linear_20485_87116)"
			stroke="#190A28"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.2381 36C34.616 36 34.9224 35.6936 34.9224 35.3156V21.508C34.9224 21.2957 34.824 21.0955 34.6559 20.966L23.4591 12.3346C23.2054 12.1391 22.8499 12.1457 22.6036 12.3505L12.2467 20.9662C12.0904 21.0962 12 21.289 12 21.4923V35.3156C12 35.6936 12.3064 36 12.6844 36H34.2381Z"
			fill="#FFF2EB"
			stroke="#190A28"
		/>
		<path
			d="M21 35.4012C21 35.7319 21.2681 36 21.5988 36H25.4012C25.7319 36 26 35.7319 26 35.4012V29C26 28.4477 25.5523 28 25 28H22C21.4477 28 21 28.4477 21 29V35.4012Z"
			fill="#FFF2EB"
			stroke="#190A28"
		/>
		<path
			d="M31.3839 24.9231C31.3839 24.9231 35.9993 19.2217 35.9993 16.6523C35.9993 14.0829 33.9329 12 31.3839 12C28.8349 12 26.7686 14.0829 26.7686 16.6523C26.7686 19.2217 31.3839 24.9231 31.3839 24.9231Z"
			fill="url(#paint1_linear_20485_87116)"
			stroke="#190A28"
		/>
		<path
			d="M31.3841 18.3969C32.34 18.3969 33.1149 17.6159 33.1149 16.6523C33.1149 15.6888 32.34 14.9077 31.3841 14.9077C30.4282 14.9077 29.6533 15.6888 29.6533 16.6523C29.6533 17.6159 30.4282 18.3969 31.3841 18.3969Z"
			fill="#EBF3FE"
			stroke="#190A28"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_87116"
				x1={12.579}
				y1={14.7686}
				x2={17.9019}
				y2={17.9165}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_87116"
				x1={23.7869}
				y1={16.1743}
				x2={32.8991}
				y2={26.2494}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
		</defs>
	</svg>
);

const NearbyTabDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814535)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="white"
			/>
			<rect
				x={10.3279}
				y={8.7998}
				width={3.05632}
				height={8}
				rx={0.466667}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M29.5556 31.1998C29.9083 31.1998 30.1943 30.9138 30.1943 30.5611V17.6739C30.1943 17.4758 30.1024 17.289 29.9455 17.168L19.4952 9.11214C19.2584 8.92959 18.9266 8.93575 18.6967 9.12698L9.0303 17.1683C8.88442 17.2896 8.80005 17.4696 8.80005 17.6593V30.5611C8.80005 30.9138 9.08603 31.1998 9.4388 31.1998H29.5556Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M17.2 30.6413C17.2 30.95 17.4502 31.2002 17.7589 31.2002H21.3077C21.6164 31.2002 21.8666 30.95 21.8666 30.6413V24.6669C21.8666 24.1514 21.4488 23.7335 20.9333 23.7335H18.1333C17.6178 23.7335 17.2 24.1514 17.2 24.6669V30.6413Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M26.8922 20.8613C26.8922 20.8613 31.1999 15.5401 31.1999 13.142C31.1999 10.7439 29.2712 8.7998 26.8922 8.7998C24.5131 8.7998 22.5845 10.7439 22.5845 13.142C22.5845 15.5401 26.8922 20.8613 26.8922 20.8613Z"
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
			<path
				d="M26.892 14.7703C27.7841 14.7703 28.5074 14.0413 28.5074 13.142C28.5074 12.2427 27.7841 11.5137 26.892 11.5137C25.9998 11.5137 25.2766 12.2427 25.2766 13.142C25.2766 14.0413 25.9998 14.7703 26.892 14.7703Z"
				fill="#EBF3FE"
				stroke="#190A28"
				strokeWidth={0.933333}
			/>
		</g>
		<defs>
			<clipPath id="clip0_20351_814535">
				<rect width={40} height={40} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const NearbyTabSelectedDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20514_364474)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="#FED9C3"
			/>
			<g clipPath="url(#clip1_20514_364474)">
				<rect
					x={10.3279}
					y={8.7998}
					width={3.05632}
					height={8}
					rx={0.466667}
					fill="url(#paint0_linear_20514_364474)"
					stroke="#190A28"
					strokeWidth={0.933333}
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M29.5556 31.1998C29.9083 31.1998 30.1943 30.9138 30.1943 30.5611V17.6739C30.1943 17.4758 30.1024 17.289 29.9455 17.168L19.4952 9.11214C19.2584 8.92959 18.9266 8.93575 18.6967 9.12698L9.0303 17.1683C8.88442 17.2896 8.80005 17.4696 8.80005 17.6593V30.5611C8.80005 30.9138 9.08603 31.1998 9.4388 31.1998H29.5556Z"
					fill="#FFF2EB"
					stroke="#190A28"
					strokeWidth={0.933333}
				/>
				<path
					d="M17.2 30.6413C17.2 30.95 17.4502 31.2002 17.7589 31.2002H21.3077C21.6164 31.2002 21.8666 30.95 21.8666 30.6413V24.6669C21.8666 24.1514 21.4488 23.7335 20.9333 23.7335H18.1333C17.6178 23.7335 17.2 24.1514 17.2 24.6669V30.6413Z"
					fill="#FFF2EB"
					stroke="#190A28"
					strokeWidth={0.933333}
				/>
				<path
					d="M26.8922 20.8613C26.8922 20.8613 31.1999 15.5401 31.1999 13.142C31.1999 10.7439 29.2712 8.7998 26.8922 8.7998C24.5131 8.7998 22.5845 10.7439 22.5845 13.142C22.5845 15.5401 26.8922 20.8613 26.8922 20.8613Z"
					fill="url(#paint1_linear_20514_364474)"
					stroke="#190A28"
					strokeWidth={0.933333}
				/>
				<path
					d="M26.892 14.7703C27.7841 14.7703 28.5074 14.0413 28.5074 13.142C28.5074 12.2427 27.7841 11.5137 26.892 11.5137C25.9998 11.5137 25.2766 12.2427 25.2766 13.142C25.2766 14.0413 25.9998 14.7703 26.892 14.7703Z"
					fill="#EBF3FE"
					stroke="#190A28"
					strokeWidth={0.933333}
				/>
			</g>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_20514_364474"
				x1={9.34066}
				y1={11.3839}
				x2={14.3087}
				y2={14.3218}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20514_364474"
				x1={19.8016}
				y1={12.6958}
				x2={28.3063}
				y2={22.0992}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FF8800" />
				<stop offset={1} stopColor="#E63535" />
			</linearGradient>
			<clipPath id="clip0_20514_364474">
				<rect width={40} height={40} fill="white" />
			</clipPath>
			<clipPath id="clip1_20514_364474">
				<rect width={24} height={24} fill="white" transform="translate(8 8)" />
			</clipPath>
		</defs>
	</svg>
);

const NearbyTabIcon = {
	mobile: <NearbyTabMobileIcon />,
	mobileSelected: <NearbyTabSelectedMobileIcon />,
	desktop: <NearbyTabDesktopIcon />,
	desktopSelected: <NearbyTabSelectedDesktopIcon />,
};

export default NearbyTabIcon;
